var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape_Copy_3",
    "data-name": "Shape Copy 3",
    d: "M15.5,20H.5a.52.52,0,0,1-.5-.54,5.78,5.78,0,0,1,2.343-5.035A9.694,9.694,0,0,1,8,12.973a9.694,9.694,0,0,1,5.657,1.452A5.78,5.78,0,0,1,16,19.46.52.52,0,0,1,15.5,20ZM8,11.352A3.513,3.513,0,0,1,5.068,9.386,8.07,8.07,0,0,1,4,5.405C4,2.748,5.5,0,8,0s4,2.748,4,5.405a8.071,8.071,0,0,1-1.068,3.981A3.512,3.512,0,0,1,8,11.352Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileNew);
export default __webpack_public_path__ + "static/media/profile_new.cfbbaed15a4a53ffd81b0046fb860fb6.svg";
export { ForwardRef as ReactComponent };